<template>
  <div class="video-player">
    <div class="video-player__container">
      <div class="video-player__wrapper">
        <transition name="fast-fade">
          <div v-if="type === 'video'" :key="source">
            <video
              :key="source"
              :src="$store.state.assetsPath + source"
              playsinline
              disablePictureInPicture
              ref="video"
              @ended="onEnd"
              @play="onPlay"
              @timeupdate="onTimeUpdate"
              poster="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
            />
            <div v-if="playbackProgress > 0" class="video-player__progress">
              <div class="progress-bar" :style="`width: ${playbackProgress}%`"/>
            </div>
          </div>

          <div v-if="type === 'image'" :key="source">
            <img
              :key="source"
              :src="$store.state.assetsPath + source"
              ref="image"
              alt=""
            >
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['source', 'type'],

  data () {
    return {
      playbackProgress: 0
    }
  },

  watch: {
    source () {
      this.playbackProgress = 0
    }
  },

  methods: {
    getType (source) {
      const ext = source.split('.').pop()

      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
        return 'image'
      }

      if (['mov', 'mp4', 'webm'].includes(ext)) {
        return 'video'
      }
    },

    play () {
      this.$nextTick(() => {
        this.$refs.video.play()
      })
    },

    stop () {
      this.$refs.video.pause()
      this.$refs.video.currentTime = 0
    },

    onEnd () {
      this.stop()
      this.$emit('video-ended')
    },    

    onPlay () {
      this.$emit('video-started')
    },

    onTimeUpdate () {
      if (!this.$refs.video) return

      const video = this.$refs.video
      if (video && !isNaN(video.duration)) {
        this.playbackProgress = video.currentTime / video.duration * 100
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-player {
  bottom: 19rem;
  height: 56.25rem;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 100rem;
  z-index: 100;

  &__container {
    height: 100%;
    position: relative;
    width: 100%;
  }

  &__wrapper {
    background: rgba(#000, .8);
    border-radius: .5rem;
    bottom: 0;
    box-shadow: .5rem .5rem 2rem rgba(0, 0, 0, .8);
    left: 0;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;

    video,
    img {
      height: 100%;
      position: absolute;
      object-fit: contain;
      width: 100%;
    }

    img {
      object-fit: cover;
    }
  }

  &__progress {
    // background: rgba(0,0,0, .5);
    bottom: 0;
    height: .5rem;
    left: 0;
    position: absolute;
    right: 0;

    .progress-bar {
      background: #eaeaea;
      height: 100%;
      opacity: .75;
      position: relative;
      width: 0;
    }
  }
}
</style>